module.exports = __webpack_public_path__ + "img/logo.79f26140.png";